import cx from 'classnames';
import * as React from 'react';

export const Card = ({ className, ...props }: JSX.IntrinsicElements['div']) => (
  <div className={cx('shadow bg-white p-2', className)} {...props} />
);
